import React from 'react'
import NavbarContainer from '../components/NavbarContainer/NavbarContainer'
import RegisterationStudentContaier from '../components/RegisterationStudentContaier/RegisterationStudentContaier'
import CommonHeader from '../components/CommonHeader/CommonHeader'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

function RegisterationStudent() {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  const { id } = useParams();
  const { stgeesArray } = useSelector((state) => state.stages);
  const departmentTranslations = {
    "قسم الاساسي ( من الصف الاول الى الصف العاشر)": {
      en: "Basic Section",
    },
    'قسم ما بعد الأساسي( من الصف الحادي عشر الى الصف الثاني عشر)': {
      en: "Post-Basic Section",
    },

    "قسم التعليم المبكر ( رياض الأطفال)": {
      en: "Early Childhood Section (Kindergarten)",
    },
    "قسم ثنائي اللغة": {
      en: "Bilingual Section",
    }
  };

  const stage = stgeesArray.filter((item) => item?.value == id)

  const withEnglish = stage.map(item => ({
    ...item,
    label_en: departmentTranslations[item.label]?.en || item.label,


  }));
  return (
    <div>
      <NavbarContainer />
      <div  className='pt-5'>
      <CommonHeader
        title={currentLocal.language == "العربيه" ? withEnglish[0]?.label : withEnglish[0]?.label_en}
      />
      </div>

      <RegisterationStudentContaier
        stage={stage}
      />
    </div>
  )
}

export default RegisterationStudent